type RuntimeEnv = {
  VITE_POCKETBASE_URL?: string
  VITE_POCKETBASE_AUTH_COLLECTION?: string
  VITE_JOBCARDS_ROADMAP_URL?: string
  VITE_TITLE_PREFIX?: string
  VITE_SHOW_DEV_CHROME?: string
  VITE_SENTRY_DSN?: string
  VITE_SENTRY_ENVIRONMENT?: string
  VITE_SENTRY_TRACES_SAMPLE_RATE?: string
}

const runtimeEnv: RuntimeEnv = {
  VITE_POCKETBASE_URL: import.meta.env.VITE_POCKETBASE_URL,
  VITE_POCKETBASE_AUTH_COLLECTION: import.meta.env.VITE_POCKETBASE_AUTH_COLLECTION,
  VITE_JOBCARDS_ROADMAP_URL: import.meta.env.VITE_JOBCARDS_ROADMAP_URL,
  VITE_TITLE_PREFIX: import.meta.env.VITE_TITLE_PREFIX,
  VITE_SHOW_DEV_CHROME: import.meta.env.VITE_SHOW_DEV_CHROME,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  VITE_SENTRY_TRACES_SAMPLE_RATE: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
}

const runtimeEnvKeys: (keyof RuntimeEnv)[] = [
  'VITE_POCKETBASE_URL',
  'VITE_POCKETBASE_AUTH_COLLECTION',
  'VITE_JOBCARDS_ROADMAP_URL',
  'VITE_TITLE_PREFIX',
  'VITE_SHOW_DEV_CHROME',
  'VITE_SENTRY_DSN',
  'VITE_SENTRY_ENVIRONMENT',
  'VITE_SENTRY_TRACES_SAMPLE_RATE',
]

function isSet(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0
}

export async function loadRuntimeEnv() {
  const needsFetch = runtimeEnvKeys.some((key) => !isSet(runtimeEnv[key]))
  if (!needsFetch) {
    return runtimeEnv
  }

  try {
    const response = await fetch('/env.json', { cache: 'no-store' })
    if (!response.ok) {
      return runtimeEnv
    }
    const data = (await response.json()) as Record<string, unknown>
    for (const key of runtimeEnvKeys) {
      if (!isSet(runtimeEnv[key]) && isSet(data[key])) {
        runtimeEnv[key] = data[key]
      }
    }
  } catch {
    return runtimeEnv
  }

  return runtimeEnv
}

export function getRuntimeEnv() {
  return runtimeEnv
}
